import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Facebook } from "lucide-react";
import { Button } from "@/components/ui/button";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Issues", path: "/issues" },
  { name: "About Matt", path: "/about" },
  { name: "News", path: "/news" },
  { name: "Volunteer", path: "/volunteer" },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-[60] focus:top-4 focus:left-4 focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded">
        Skip to main content
      </a>
      <header className="sticky top-0 z-50 bg-card/95 backdrop-blur-sm border-b border-border shadow-sm">
        <div className="container mx-auto px-4">
        <nav className="flex items-center justify-between h-20" aria-label="Main navigation">
          {/* Logo */}
          <Link to="/">
            <img 
              src="/lovable-uploads/99d5ab1a-5919-4395-8109-cb67912397d5.jpg" 
              alt="Matt Bucher for State Representative" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-body font-semibold text-sm uppercase tracking-wide transition-colors hover:text-primary ${
                  location.pathname === link.path
                    ? "text-primary"
                    : "text-foreground"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://www.facebook.com/profile.php?id=100077991582201"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground hover:text-primary transition-colors"
              aria-label="Visit Matt Bucher Campaign on Facebook"
            >
              <Facebook className="h-5 w-5" aria-hidden="true" />
            </a>
            <Button variant="cta" size="lg" asChild>
              <Link to="/donate">Donate</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-foreground" aria-hidden="true" />
            ) : (
              <Menu className="h-6 w-6 text-foreground" aria-hidden="true" />
            )}
          </button>
        </nav>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav id="mobile-menu" className="md:hidden py-4 border-t border-border animate-fade-in" aria-label="Mobile navigation">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-body font-semibold text-base uppercase tracking-wide py-2 transition-colors hover:text-primary ${
                    location.pathname === link.path
                      ? "text-primary"
                      : "text-foreground"
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://www.facebook.com/profile.php?id=100077991582201"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 font-body font-semibold text-base uppercase tracking-wide py-2 text-foreground hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                <Facebook className="h-5 w-5" aria-hidden="true" />
                Facebook
              </a>
              <Button variant="cta" size="lg" asChild className="mt-2">
                <Link to="/donate" onClick={() => setIsMenuOpen(false)}>
                  Donate
                </Link>
              </Button>
            </div>
          </nav>
        )}
        </div>
      </header>
    </>
  );
};

export default Header;
